import * as React from 'react';
export const xrpSvg = React.forwardRef(function xrpSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.301 7.038h2.985l-6.214 6.444a5.613 5.613 0 0 1-8.144 0L5.713 7.038h2.985l4.719 4.895a3.558 3.558 0 0 0 5.158 0l4.726-4.895ZM8.661 24.963H5.674l6.254-6.487a5.617 5.617 0 0 1 8.149 0l6.254 6.487h-2.986l-4.76-4.938a3.558 3.558 0 0 0-5.158 0l-4.766 4.938Z',
      fill: '#fff',
    }),
  );
});
xrpSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var xrp = {
  category: 'brand',
  colorable: false,
  name: 'xrp',
  svg: xrpSvg,
};
